var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06218 12.689L14.997 2.08959C15.1987 1.89406 15.6187 2.04586 15.5324 2.28312L12.9525 9.37986C12.9091 9.49934 13.0053 9.62216 13.1674 9.65417L19.7746 10.9591C19.9832 11.0003 20.0686 11.1843 19.9378 11.311L9.00299 21.9104C8.80128 22.1059 8.38133 21.9541 8.46759 21.7169L11.0475 14.6201C11.0909 14.5007 10.9947 14.3778 10.8326 14.3458L4.22542 13.0409C4.01679 12.9997 3.93145 12.8157 4.06218 12.689Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.79369fac2fd6840cbe60d81cae6a71dc.svg";
export { ForwardRef as ReactComponent };